var _rect, _ellipse, _rect2, _rect3, _rect4, _text, _text2, _text3, _text4, _text5, _rect5, _text6, _rect6, _rect7, _text7, _rect8, _text8, _rect9, _text9, _rect10, _text10, _text11, _text12, _text13, _text14, _rect11, _text15, _rect12, _text16, _rect13, _text17, _text18, _rect14, _rect15, _text19, _text20, _text21, _text22, _rect16, _rect17, _text23, _text24, _text25, _text26, _rect18, _rect19, _text27, _text28, _text29, _text30, _rect20, _rect21, _text31, _text32, _rect22, _text33, _rect23, _text34, _rect24, _text35, _rect25, _text36, _text37, _rect26, _text38, _rect27, _text39, _text40, _text41, _text42, _text43, _rect28, _text44, _text45, _text46, _text47, _text48, _rect29, _rect30, _text49, _text50, _text51, _text52, _text53, _text54, _rect31, _text55, _text56, _text57, _text58, _text59, _text60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateAiWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    width: 1200,
    height: 675,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0a1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f0f2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purple",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#7c3aed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6d28d9"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e1b4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0a0a1a"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#bg3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 200,
    rx: 500,
    ry: 180,
    fill: "#7c3aed",
    opacity: 0.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 60,
    fill: "#0a0a1a",
    opacity: 0.97
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59,
    width: 1200,
    height: 1,
    fill: "#1e1b4b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#7c3aed"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 34,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "P")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 36,
    fill: "#f8fafc",
    fontSize: 16,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Private")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 36,
    fill: "#7c3aed",
    fontSize: 16,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "AI")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 36,
    fill: "#94a3b8",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Industry")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 36,
    fill: "#94a3b8",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Learn More")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 16,
    width: 110,
    height: 30,
    rx: 8,
    fill: "url(#purple)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1115,
    y: 35,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Get Started")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60,
    width: 1200,
    height: 240,
    fill: "url(#hero)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 80,
    width: 80,
    height: 32,
    rx: 6,
    fill: "#1e1b4b",
    stroke: "#7c3aed",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 100,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "ISO 27001")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 80,
    width: 80,
    height: 32,
    rx: 6,
    fill: "#1e1b4b",
    stroke: "#7c3aed",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 100,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "ISO 27701")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 80,
    width: 60,
    height: 32,
    rx: 6,
    fill: "#1e1b4b",
    stroke: "#10b981",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1070,
    y: 100,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontSize: 10,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "GDPR")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 80,
    width: 70,
    height: 32,
    rx: 6,
    fill: "#1e1b4b",
    stroke: "#f59e0b",
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1145,
    y: 100,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontSize: 10,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "HIPAA")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 130,
    fill: "#f8fafc",
    fontSize: 32,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Secure AI for Business")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 168,
    fill: "#a78bfa",
    fontSize: 22,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Your Data, Your AI, Your Control")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 202,
    fill: "#64748b",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "Data privacy built for enterprise. ISO 27001 &amp; 27701 certified.")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 222,
    fill: "#64748b",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "GDPR \xB7 HIPAA \xB7 SOC 2 aligned.")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 245,
    width: 140,
    height: 38,
    rx: 8,
    fill: "url(#purple)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 268,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Schedule Demo")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 245,
    width: 110,
    height: 38,
    rx: 8,
    fill: "transparent",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 307,
    y: 268,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "Learn More")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300,
    width: 1200,
    height: 10,
    fill: "#0d0d1f"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 342,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontSize: 20,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Why PrivateAI?")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 366,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Your team needs AI \u2014 your data is too valuable to risk")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 385,
    width: 230,
    height: 120,
    rx: 12,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 400,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#7c3aed",
    opacity: 0.25
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 423,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 18
  }, "\uD83D\uDD12")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 456,
    fill: "#f8fafc",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Private by Design")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 474,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "No data shared with")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 490,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "third parties")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 385,
    width: 230,
    height: 120,
    rx: 12,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 400,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#7c3aed",
    opacity: 0.25
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 423,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 18
  }, "\uD83E\uDDE0")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 456,
    fill: "#f8fafc",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Smart for Business")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 474,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "GDrive, OneDrive,")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 490,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Email + Advanced RAG")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 385,
    width: 230,
    height: 120,
    rx: 12,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 400,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#7c3aed",
    opacity: 0.25
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 593,
    y: 423,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 18
  }, "\uD83D\uDC65")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 456,
    fill: "#f8fafc",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Team Ready")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 474,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Easy chat UI, user mgmt,")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 490,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "setup in days")), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 385,
    width: 330,
    height: 120,
    rx: 12,
    fill: "#0f0f2e",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 825,
    y: 400,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#7c3aed",
    opacity: 0.25
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 843,
    y: 423,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 18
  }, "\u26A1")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 825,
    y: 456,
    fill: "#f8fafc",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "250+ Integrations")), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 825,
    y: 465,
    width: 50,
    height: 20,
    rx: 4,
    fill: "#1e1b4b"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 850,
    y: 479,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "sans-serif"
  }, "Slack")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 883,
    y: 465,
    width: 55,
    height: 20,
    rx: 4,
    fill: "#1e1b4b"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 910,
    y: 479,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "sans-serif"
  }, "GDrive")), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 946,
    y: 465,
    width: 50,
    height: 20,
    rx: 4,
    fill: "#1e1b4b"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 971,
    y: 479,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "sans-serif"
  }, "Teams")), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1004,
    y: 465,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#1e1b4b"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 1034,
    y: 479,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "sans-serif"
  }, "Salesforce")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 825,
    y: 498,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "+ many more weekly")), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 518,
    width: 1200,
    height: 157,
    fill: "#080818"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 548,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Our Plans")), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 562,
    width: 240,
    height: 95,
    rx: 10,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    fill: "#64748b",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Solo")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 612,
    fill: "#f8fafc",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "$299")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 612,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "/month")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 635,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "1 seat \xB7 2 data sources")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 650,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Boutique firms")), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 562,
    width: 240,
    height: 95,
    rx: 10,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 588,
    fill: "#64748b",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Starter")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 612,
    fill: "#f8fafc",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "$994")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 612,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "/month")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 635,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "10 seats \xB7 2 sources")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 650,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Small teams")), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 556,
    width: 240,
    height: 107,
    rx: 10,
    fill: "#1e1b4b",
    stroke: "#7c3aed",
    strokeWidth: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 556,
    width: 100,
    height: 20,
    rx: 4,
    fill: "#7c3aed"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 570,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Most Popular")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 596,
    fill: "#a78bfa",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Pro")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 620,
    fill: "#f8fafc",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "$1,986")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 620,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "/month")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 641,
    fill: "#94a3b8",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "20 seats \xB7 5 sources")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 656,
    fill: "#94a3b8",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Growing teams")), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 562,
    width: 300,
    height: 95,
    rx: 10,
    fill: "#0f0f2e",
    stroke: "#1e1b4b",
    strokeWidth: 1
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 588,
    fill: "#64748b",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Enterprise")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 612,
    fill: "#f8fafc",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "$11,417")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 965,
    y: 612,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "/month")), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 635,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "50 seats \xB7 10 sources")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 650,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Dedicated AI model")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 670,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Built with WordPress \xB7 AI Chatbot Integration \xB7 Enterprise Security \xB7 useprivate.ai")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateAiWebsite);
export default __webpack_public_path__ + "static/media/private-ai-website.e0c4db7c9345af16a7131ba88a64385c.svg";
export { ForwardRef as ReactComponent };